"use client";
import React, { useState } from "react";
import { getLogoBaseUrl } from "../../utils/assets";
import ContainerOverlay from "./children/ContainerOverlay";
import { MainNavigation } from "./children/MainNavigation";
import { NavContainer } from "./children/NavContainer";
import { UserNavigation } from "./children/UserNavigation";
import styles from "./NavigationHeader.module.scss";
const MainLogo = () => (<a className={styles.logo} href="/">
    <img src={getLogoBaseUrl("haven_logo_colour.svg")} className={styles.logoImage} width="110" height="40" alt="Haven.com"/>
  </a>);
export const NavigationHeader = ({ analytics, className = "", userLoggedIn = false, userLogoutOnClick = () => { }, identity, }) => {
    const [isMainMenuOpen, setMainMenuOpen] = useState(false);
    const [isUserMenuOpen, setUserMenuOpen] = useState(false);
    const updateAccountMenu = (open) => {
        setUserMenuOpen(open);
        if (open) {
            setMainMenuOpen(false);
        }
    };
    const updateMainMenu = (open) => {
        setMainMenuOpen(open);
        if (open) {
            setUserMenuOpen(false);
        }
    };
    const closeMenus = () => {
        setMainMenuOpen(false);
        setUserMenuOpen(false);
    };
    return (<header className={`${styles.header} ${className}`}>
      <div className={styles.container}>
        <NavContainer isMenuOpen={isMainMenuOpen} setMenuOpen={updateMainMenu} analytics={analytics}>
          <MainNavigation analytics={analytics} isMainMenuOpen={isMainMenuOpen} setMenuOpen={setMainMenuOpen}/>
        </NavContainer>
        <MainLogo />
        <UserNavigation analytics={analytics} userLoggedIn={userLoggedIn} userLogoutOnClick={userLogoutOnClick} identity={identity} isMenuOpen={isUserMenuOpen} setMenuOpen={updateAccountMenu}/>
        {(isMainMenuOpen || isUserMenuOpen) && (<ContainerOverlay closeMenus={closeMenus}/>)}
      </div>
    </header>);
};
